import styled from 'styled-components';

import { Dropdown as DefaultDropdown } from '@xing-com/text-field';
import {
  scale005,
  scale010,
  scale100,
  scale110,
  xdlColorControlBorder,
} from '@xing-com/tokens';

const customDropdownWidth = '481px';
const customDropdownHeight = '48px';

export const Dropdown = styled(DefaultDropdown)`
  max-width: ${customDropdownWidth};
  height: ${customDropdownHeight};
  & select {
    padding: 0px 0px 0px ${scale100};
    gap: 0px;
    border-radius: ${scale110};
    border-width: ${scale005};

    /* Override of the default styles */

    border-color: ${xdlColorControlBorder};
    &:focus {
      border: ${scale010} solid ${xdlColorControlBorder} !important;
    }
    &:hover {
      border: ${scale010} solid ${xdlColorControlBorder};
    }
  }
`;
